// removed by extract-text-webpack-plugin
module.exports = {"popoverIconContainer":"popoverIconContainer___3qfab"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PopoverIcon/PopoverIcon.module.less
// module id = 3595
// module chunks = 29